import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";
import { blockResourcesCommandZodObject } from "./block-resources.command";

const blockResourcesMultiCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("BLOCK_RESOURCES_MULTI_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    providerId: providerIdZodSchema,
    commands: z.array(blockResourcesCommandZodObject).min(1),
});
type BlockResourcesMultiCommand = z.infer<
    typeof blockResourcesMultiCommandZodObject
>;

const blockResourcesMultisCommandFactoryParamsZodObject =
    blockResourcesMultiCommandZodObject.omit({
        _id: true,
        _type: true,
        _createdAt: true,
    });
type FactoryParams = z.infer<
    typeof blockResourcesMultisCommandFactoryParamsZodObject
>;
const blockResourcesMultiCommandFactory = (params: FactoryParams) => {
    const command: BlockResourcesMultiCommand = {
        ...params,
        _id: generateId({ prefix: "block_resources_multi_command__" }),
        _type: "BLOCK_RESOURCES_MULTI_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

export {
    blockResourcesMultiCommandFactory,
    blockResourcesMultiCommandZodObject,
    blockResourcesMultisCommandFactoryParamsZodObject,
};
export type { BlockResourcesMultiCommand };
